import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ValueState } from "../state";
import { StatefulAccessor } from "./StatefulAccessor";
export var PaginationAccessor =
/*#__PURE__*/
function (_StatefulAccessor) {
  _inherits(PaginationAccessor, _StatefulAccessor);

  function PaginationAccessor() {
    var _this;

    _classCallCheck(this, PaginationAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PaginationAccessor).apply(this, arguments));
    _this.state = new ValueState();
    return _this;
  }

  _createClass(PaginationAccessor, [{
    key: "onStateChange",
    value: function onStateChange() {
      var oldState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (oldState[this.urlKey] == this.state.getValue()) {
        this.state = this.state.clear();
      }
    }
  }, {
    key: "buildOwnQuery",
    value: function buildOwnQuery(query) {
      var from = (query.getSize() || 20) * (Number(this.state.getValue()) - 1);

      if (from > 0) {
        return query.setFrom(from);
      }

      return query;
    }
  }]);

  return PaginationAccessor;
}(StatefulAccessor);